import React, { useEffect, useRef, useState } from "react";
import Sidebar from "../../Sidebar";
import Header from "../../Header";
import axios from "axios";
import { API } from "../../../../API";
import { isAutheticated } from "../../../auth/authhelper";
import { Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import swal from "sweetalert";
import ClipLoader from "react-spinners/ClipLoader";
import $ from "jquery";
import { Player } from "video-react";
import "video-react/dist/video-react.css";
import { useHistory, Link } from "react-router-dom";
import Footer from "../../Footer";
// import { Link } from "react-router-dom";

export default function AddLession() {
  const { token } = isAutheticated();
  const tab1 = useRef(null);
  const tab2 = useRef(null);
  const [lession, setLession] = useState({
    madeBy: "",
    title: "",
    description: "",
    // subject: "",
    channel: "",
    languageid: "",
    live: false,
    thumbnail: "",
    banner: "",
    launch: false,
    launchDate: new Date(),
    video: "",
  });
  const [loading, setLoading] = useState(false);
  const [Validation, setValidation] = useState(false);
  const [searchMovie, setSearchMovie] = useState("");
  const [movieList, setMovieList] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [formData, setFormData] = useState(new FormData());
  const [metaformData, setMetaformData] = useState({});
  const [validForm, setvalidForm] = useState(false);
  const [error, setError] = useState("");
  const [lessionId, setLessionId] = useState(null);
  const [success, setSuccess] = useState(false);
  const [currentTab, setcurrentTab] = useState(1);
  const [metaDataTitle, setmetaDataTitle] = useState("");
  const [metaDataPlot, setmetaDataPlot] = useState("");
  const [metaDataDirector, setmetaDataDirector] = useState("");
  const [metaDataWriter, setmetaDataWriter] = useState("");
  const [metaDataCrew, setmetaDataCrew] = useState([]);
  const [channels, setChannels] = useState([]);
  const [channelloading, setchannelLoading] = useState(true);
  const [progress, setProgress] = useState(0);
  // var metaformData={}

  const wordLimit = {
    title: 50,
    description: 600,
  };

  const [titleLen, setTitleLen] = useState(wordLimit.title);
  const [descriptionLen, setDescriptionLen] = useState(wordLimit.description);

  const history = useHistory();

  useEffect(() => {
    const checkForm = () => {
      if (lession.title.length != 0 && lession.thumbnail != "") {
        setError("");
        setvalidForm(true);
        // console.log("true");
      } else {
        setError("All fields are must!");
        setvalidForm(false);
      }
    };
    checkForm();
  }, [lession]);

  //get Channel
  const fetchChannels = async () => {
    setchannelLoading(true)
    try {
      const response = await axios.get(`${API}/api/channel/view_all_channel`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }); // Replace with your actual API endpoint
      console.log(response.data?.channels)
      setChannels(response.data?.channels || []);
    } catch (error) {
      console.error("Error fetching Channels:", error);
    } finally {
      setchannelLoading(false);
    }
  };
  useEffect(() => {
    fetchChannels();
  }, []);

  useEffect(() => {
    // $("#summernote").summernote();
    axios
      .get(`${API}/api/languages`)
      .then((response) => {
        // console.log(response);
        setLanguages(response.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
    return () => {
      setLanguages({});
    };
  }, []);

  const handleChange = (e) => {
    e.preventDefault();
    // console.log(e.target?.value)
    const { value, name } = e.target;

    if (name == "video") {
      /*Maximum allowed size in bytes
        5MB Example
        Change first operand(multiplier) for your needs*/
      const maxAllowedSize = 500 * 1024 * 1024;
      if (e.target.files[0]?.type !== "video/mp4") {
        e.target.value = "";
        swal({
          title: "Video should be of mp4 only",
          icon: "error",
          button: "Close",
          dangerMode: true,
        });
        return;
      }
      if (e.target.files[0].size > maxAllowedSize) {
        e.target.value = "";
        swal({
          title: "Your video file size must be less than 500mb",
          icon: "error",
          button: "Close",
          dangerMode: true,
        });
        return;
      }
      setLession({ ...lession, video: URL.createObjectURL(e.target.files[0]) });
      formData.set("video", e.target.files[0]);
    } else if (name == "thumbnail") {
      // console.log(e.target.files[0].type);
      if (
        e.target.files[0]?.type === "image/jpeg" ||
        e.target.files[0]?.type === "image/png" ||
        e.target.files[0]?.type === "image/jpg"
      ) {
        setLession({
          ...lession,
          thumbnail: URL.createObjectURL(e.target.files[0]),
        });
        formData.set(name, e.target.files[0]);
        setValidation(false);
      } else {
        e.target.value = null;
        setValidation(true);
      }
    } else if (name == "banner") {
      setLession({
        ...lession,
        [name]: URL.createObjectURL(e.target.files[0]),
      });
      formData.set(name, e.target.files[0]);
    } else {
      setLession({ ...lession, [name]: value });
      formData.set(name, value);
    }
  };

  // const onSubmit = async (e) => {
  //   e.preventDefault();
  //   try {
  //     if (!lessionId) {
  //       return;
  //     }
  //     setLoading(true);
  //     formData.delete("thumbnail");
  //     const responseVideo = await axios.post(
  //       `${API}/api/lesson/${lessionId}/video`,
  //       formData,
  //       {
  //         headers: {
  //           "Access-Control-Allow-Origin": "*",
  //           Authorization: `Bearer ${token}`,
  //           "Content-Type": "multipart/formdata",
  //         },
  //       }
  //     );
  //     // console.log(response);
  //     setLoading(false);
  //     // console.log(response);
  //     setSuccess(true);
  //     history.push("/lessions");
  //   } catch (err) {
  //     console.log(err);
  //     // console.log(err.response);
  //     setLoading(false);
  //     let message = err?.response?.data?.message;
  //     swal({
  //       title: "Error",
  //       text: message || "try again",
  //       icon: "error",
  //       buttons: true,
  //       dangerMode: true,
  //     });
  //     console.log(err);
  //   }
  // };



  const onSubmit = async (e) => {
    e.preventDefault();

    if (!lessionId) {
      swal({
        title: "Error",
        text: "video ID is missing!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      });
      return;
    }

    try {
      setLoading(true);
      setProgress(0); // Reset progress before upload starts

      // Ensure thumbnail is removed if unnecessary
      formData.delete("thumbnail");

      const responseVideo = await axios.post(
        `${API}/api/lesson/${lessionId}/video`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setProgress(percentCompleted); // Update progress state
          },
        }
      );

      // Handle success
      setLoading(false);
      setProgress(0); // Reset progress after successful upload
      setSuccess(true);

      swal({
        title: "Success",
        text: "Video uploaded successfully!",
        icon: "success",
        buttons: true,
      });

      // Navigate to lessons page
      history.push("/videos");
    } catch (err) {
      // Handle errors
      console.error("Upload error:", err);
      setLoading(false);
      setProgress(0); // Reset progress in case of error

      const message =
        err?.response?.status === 413
          ? "The uploaded file is too large. Please upload a smaller file."
          : err?.response?.data?.message || "An error occurred. Try again!";
      swal("Error", message, "error");

    }
  };








  // const onUpdatefirst = (e) => {
  //   e.preventDefault();
  //   setLoading(true);
  //   // setSuccess(false);
  //   formData.delete("video");
  //   axios
  //     .post(`${API}/api/lesson/`, formData, {
  //       headers: {
  //         "Access-Control-Allow-Origin": "*",
  //         Authorization: `Bearer ${token}`,
  //         "Content-Type": "multipart/formdata",
  //       },
  //     })
  //     .then((response) => {
  //       // console.log("updated object", response);
  //       setLessionId(response.data.data._id);
  //       setLoading(false);
  //       // console.log(response);
  //       // setSuccess(!success);
  //       swal({
  //         title: "Changes are saved Successfully!",

  //         icon: "success",
  //         buttons: {
  //           SaveAndExit: {
  //             text: "Save and Exit",
  //             value: "SaveAndExit",
  //           },
  //           OkCancel: {
  //             text: "Save And Continue",
  //             value: "SaveAndContinue",
  //           },
  //         },
  //       }).then((value) => {
  //         switch (value) {
  //           case "SaveAndExit":
  //             history.push("/lessions");
  //             break;
  //           case "SaveAndContinue":
  //             tab2.current.click();
  //             break;

  //           default:
  //             tab2.current.click();
  //         }
  //       });
  //     })
  //     .catch((err) => {
  //       setLoading(false);
  //       // setSuccess(!success);
  //       let message = "errror";
  //       swal({
  //         title: "Error",
  //         text: { message },
  //         icon: "error",
  //         buttons: true,
  //         dangerMode: true,
  //       });
  //       console.log(err);
  //     });
  // };
  const onUpdatefirst = (e) => {
    e.preventDefault();
    setLoading(true);
    formData.delete("video");
    formData.set("channelType", "Channels"); // Use set to ensure it's a string
    axios
      .post(`${API}/api/lesson/`, formData, {
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/formdata",
        },
      })
      .then((response) => {
        setLessionId(response.data.data._id);
        setLoading(false);
        swal({
          title: "Changes are saved Successfully!",
          icon: "success",
          buttons: {
            SaveAndExit: {
              text: "Save and Exit",
              value: "SaveAndExit",
            },
            OkCancel: {
              text: "Save And Continue",
              value: "SaveAndContinue",
            },
          },
        }).then((value) => {
          switch (value) {
            case "SaveAndExit":
              history.push("/videos");
              break;
            case "SaveAndContinue":
              tab2.current.click();
              break;

            default:
              tab2.current.click();
          }
        });
      })
      .catch((err) => {
        setLoading(false);
        let message = err?.response?.data?.message || "An error occurred. Please try again."; // Provide a meaningful error message
        swal({
          title: "Error",
          text: message, // Use `message` directly as a string
          icon: "error",
          buttons: true,
          dangerMode: true,
        });
        console.log(err);
      });
  };


  const handleEdit = (e, type) => {
    const length = e.target.value.length;
    switch (type) {
      case "title":
        if (wordLimit.title - length !== -1) {
          handleChange(e);
          setTitleLen(wordLimit.title - length);
        }
        break;
      case "description":
        if (wordLimit.description - length !== -1) {
          handleChange(e);
          setDescriptionLen(wordLimit.description - length);
        }
        break;
      case "channel":
        if (type === 'channel') {
          handleChange(e);
          // setDescriptionLen(wordLimit.description - length);
        }
        break;
      default:
        console.log("Incorrect Type");
    }
  };

  return (
    <div className='main-content'>
      <div className='page-content'>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-12'>
              <div className='page-title-box d-flex align-items-center justify-content-between'>
                <h4 className='mb-0'>Content Management - Video</h4>
                {/* {console.log(subjects)} */}
                {/* {console.log(languages)} */}
                <div className='page-title-right'>
                  <ol className='breadcrumb m-0'>
                    <li className='breadcrumb-item'>
                      <Link to='/'>SoComOTT</Link>
                    </li>
                    <li className='breadcrumb-item'>
                      Content Management - Video
                    </li>
                    <li className='breadcrumb-item'>Add</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <div className='row'>
            <div className='col-lg-12'>
              <div className='card'>
                <div className='card-body'>
                  <div className='row'>
                    <div className='col-md-12 col-lg-9 col-xl-8'>
                      <h1 className='text-left head-small'>Add New Video </h1>

                      <ul className='nav nav-tabs' role='tablist'>
                        <li className='nav-item waves-effect waves-light'>
                          <a
                            className='nav-link active'
                            data-toggle='tab'
                            href='#title'
                            ref={tab1}
                            role='tab'>
                            <span className='d-block d-sm-none'>
                              <img
                                alt=''
                                src='assets/images/icons/title-icon.png'
                              />
                            </span>
                            <span className='d-none d-sm-block'>Title</span>
                          </a>
                        </li>

                        <li className='nav-item waves-effect waves-light'>
                          <a
                            className={`nav-link
                              ${validForm && success ? "" : ""}`}
                            data-toggle='tab'
                            href='#video'
                            role='tab'
                            onClick={() => {
                              setcurrentTab(2);
                            }}
                            ref={tab2}>
                            <span className='d-block d-sm-none'>
                              <img
                                alt=''
                                src='assets/images/icons/video-icon.png'
                              />
                            </span>
                            <span className='d-none d-sm-block'>Video</span>
                          </a>
                        </li>
                        {/* <li className="nav-item waves-effect waves-light">
                          <a
                            className={`nav-link ${validForm &&
                              success &&
                              lession.thumbnail.length != 0 &&
                              lession.video.length != 0
                              ? ""
                              : "disabled"
                              }`}
                            data-toggle="tab"
                            href="#launch"
                            role="tab"
                            onClick={() => {
                              setcurrentTab(5);
                            }}
                            ref={tab5}
                          >
                            <span className="d-block d-sm-none">
                              <img alt="" src="assets/images/icons/date-icon.png" />
                            </span>
                            <span className="d-none d-sm-block">Launch Date</span>
                          </a>
                        </li> */}
                      </ul>

                      <div className='tab-content video-tab px-3 pt-3 text-muted'>
                        <div
                          className='tab-pane active'
                          id='title'
                          role='tabpanel'>
                          <div className='panel-body px-3 pt-3'>
                            <div className='form-group width-100 row'>
                              <label className='col-md-4 control-label'>
                                Title*
                              </label>
                              <div className='col-md-8'>
                                <input
                                  onChange={(e) => handleEdit(e, "title")}
                                  type='text'
                                  className='form-control input-field'
                                  name='title'
                                  value={lession.title}
                                />
                                <p className='pt-1 pl-2 text-secondary'>
                                  Characters Remaining: {titleLen}
                                </p>
                              </div>
                            </div>

                            <div className='form-group width-100 row'>
                              <label className='col-md-4 control-label'>
                                Description(optional)
                              </label>
                              <div className='col-md-8'>
                                <textarea
                                  onChange={(e) => handleEdit(e, "description")}
                                  value={lession.description}
                                  name='description'
                                  className='form-control input-field'
                                  rows='5'></textarea>
                                <p className='pt-1 pl-2 text-secondary'>
                                  Characters Remaining: {descriptionLen}
                                </p>
                              </div>
                            </div>
                            <div className="form-group width-100 row mb-4">
                              <label className="col-md-4 control-label">Network Channel*</label>
                              <div className="col-md-8">
                                {channelloading ? (
                                  <p>Loading Channels...</p>
                                ) : (
                                  <select
                                    onChange={(e) => handleEdit(e, "channel")}
                                    className="form-control input-field"
                                    name="channel"
                                    value={lession?.channel || ""}
                                  >
                                    <option value="" disabled>
                                      Select a Channel
                                    </option>
                                    {channels?.map((channel) => (
                                      <option key={channel?._id} value={channel?._id}>
                                        {channel.name}
                                      </option>
                                    ))}
                                  </select>
                                )}
                              </div>
                            </div>

                            {/* <div className="form-group width-100 mb-30 row">
                              <label className="col-md-4 control-label">
                                Select Language
                              </label>
                              <div className="col-md-8">
                                <select
                                  className="form-control input-field"
                                  // defaultValue=""
                                  name="languageid"
                                  onChange={handleChange}
                                  value={lession.languageid}
                                >
                                  <option value="" selected>
                                    Select Lanuage
                                  </option>
                                  {languages.length != 0 &&
                                    languages.map((lang, index) => {
                                      return (
                                        <option value={lang._id}>
                                          {lang.name}
                                        </option>
                                      );
                                    })}
                                </select>
                              </div>
                            </div> */}

                            <div
                              className='tab-pane'
                              id='images'
                              role='tabpanel'>
                              <div className='panel-body'>
                                <div className='form-group width-100 row'>
                                  <label className='col-md-4 control-label'>
                                    Upload Thumbnail Image*
                                    <br />
                                    <span className='size'>(320 x 180 px)</span>
                                  </label>
                                  <div className='col-md-8'>
                                    <span style={{ color: "red" }}>
                                      {Validation &&
                                        "Not a Valid Format for Thumbnails!"}
                                    </span>
                                    <input
                                      onChange={handleChange}
                                      name='thumbnail'
                                      type='file'
                                      className='form-control input-field'
                                      accept='image/png, image/jpg, image/jpeg'
                                    />
                                    <div>
                                      <img
                                        className='img-fluid mt-2'
                                        style={{
                                          height: "125px",
                                          width: "235px",
                                        }}
                                        alt='200x200'
                                        src={
                                          lession.thumbnail
                                            ? lession.thumbnail
                                            : "/lessionDefault.png"
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                                {/* <div className="form-group mb-30 width-100 row">
                                  <label className="col-md-4 control-label">
                                    Upload Banner Image
                                    <br />
                                    <span className="size">(320 x 180 px)</span>
                                  </label>
                                  <div className="col-md-8">
                                    <span style={{ color: "red" }}>
                                      {Validation &&
                                        "Not a Valid Format for Banner!"}
                                    </span>
                                    <input
                                      onChange={handleChange}
                                      name="banner"
                                      type="file"
                                      className="form-control input-field"
                                      accept="image/png, image/jpg, image/jpeg"
                                    />
                                    <div>
                                      <img
                                        classNameName="img-fluid mt-2"
                                        style={{
                                          height: "125px",
                                          width: "235px",
                                        }}
                                        alt="200x200"
                                        src={
                                          lession.banner
                                            ? lession.banner
                                            : "https://sgp1.digitaloceanspaces.com/storage.tellytell.com/thumbnail-default.png"
                                        }
                                      />
                                    </div>
                                  </div>
                                </div> */}
                                {/* 
                                <div className="form-group mb-30 width-100 row">
                                  <label className="col-md-4 control-label">
                                    Upload Banner Image
                                    <br />
                                    <span className="size">(1125 x 451 px)</span>
                                  </label>
                                  <div className="col-md-8">
                                    <input
                                      type="file"
                                      name="banner"
                                      onChange={handleChange}
                                      className="form-control input-field"
                                    />
                                    <div>
                                      <img
                                        classNameName="img-fluid mt-2"
                                        style={{
                                          width: "235px",
                                          height: "125px",
                                        }}
                                        alt="200x200"
                                        src={lession.banner ? lession.banner : "https://sgp1.digitaloceanspaces.com/storage.tellytell.com/banner-default.png"}
                                      />
                                    </div>
                                  </div>
                                </div> */}

                                <div className='form-group width-100 row'>
                                  <label className='col-md-4 control-label'></label>
                                  <div className='col-md-8'>
                                    <button
                                      onClick={onUpdatefirst}
                                      style={{ width: "120px" }}
                                      disabled={!validForm}
                                      type='button'
                                      className='btn btn-success btn-login waves-effect waves-light mr-3'>
                                      <ClipLoader loading={loading} size={18} />
                                      {!loading && "Save"}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* <div className="form-group width-100 mb-30 row">
                              <label className="col-md-4 control-label">
                                Select Subject
                              </label>
                              <div className="col-md-8">
                                <select
                                  className="form-control input-field"
                                  value={lession.subject}
                                  name="subject"
                                  defaultValue=""
                                  onChange={handleChange}
                                >
                                  <option value="" selected>
                                    Select Subject
                                  </option>
                                  {subjects.length != 0 &&
                                    subjects.map((subject, index) => {
                                      return (
                                        <option value={subject._id}>
                                          {subject.name}
                                        </option>
                                      );
                                    })}
                                </select>
                              </div>
                            </div> */}

                            {/* <div className="form-group mb-30 width-100 row">
                              <label className="col-md-4 text-danger control-label"></label>
                              <div className="col-md-8">
                                <button
                                  onClick={onSubmit}
                                  style={{ width: "120px" }}
                                  disabled={!validForm}
                                  type="button"
                                  className="btn btn-success btn-login waves-effect waves-light mr-3"
                                >
                                  <ClipLoader loading={loading} size={18} />
                                  {!loading && "Save"}
                                </button>
                              </div>
                            </div> */}
                          </div>
                        </div>
                        {/*/////////////////////////////// meta dat start here //////////////////// */}
                        {/* <div
                          className="tab-pane"
                          id="meta-data"
                          role="tabpanel"
                        >
                          <div className="panel-body p-20">
                            <div className="form-group mb-30 width-100 row">
                              <label className="col-md-4 control-label">
                                Search Title
                              </label>
                              <div className="col-md-8">
                                <input
                                  type="text"
                                  className="form-control input-field"
                                  value={searchMovie}
                                  onChange={(e) => {
                                    handleSearchMovie(e.target.value);
                                    setSearchMovie(e.target.value);
                                  }}
                                />
                              </div>
                            </div>
                            <div classNameName="searchedList">
                              {movieList &&
                                movieList.map((movie) => (
                                  <Link
                                    style={{ height: "7vh", display: "block" }}
                                    onClick={() => fillMetadata(movie.id)}
                                  >
                                    <img
                                      alt=""
                                      src={movie.image}
                                      style={{
                                        height: "90%",
                                        width: "6vw",
                                        marginRight: "8vw",
                                      }}
                                    />
                                    <span>{movie.title}</span>
                                    <span>{movie.description}</span>
                                  </Link>
                                ))}
                            </div>

                            <div className="form-group mb-30 width-100 row">
                              <label className="col-md-4 control-label">
                                Title
                              </label>
                              <div className="col-md-8">{metaDataTitle}</div>
                            </div>

                            <div className="form-group mb-30 width-100 row">
                              <label className="col-md-4 control-label">
                                Plot
                              </label>
                              <div className="col-md-8">{metaDataPlot}</div>
                            </div>

                            <div className="form-group mb-30 width-100 row">
                              <label className="col-md-4 control-label">
                                Director
                              </label>
                              <div className="col-md-8">
                                <div className="table-responsive table-shoot">
                                  <table className="table">
                                    <tbody>
                                      <tr> */}
                        {/* <td><img src="assets/images/avatar-2.jpg" className="img-circle" height="50" /></td> */}
                        {/* <td>{metaDataDirector}</td>
                                        <td></td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>

                            <div className="form-group mb-30 width-100 row">
                              <label className="col-md-4 control-label">
                                Writer
                              </label>
                              <div className="col-md-8">
                                <div className="table-responsive table-shoot">
                                  <table className="table">
                                    <tbody>
                                      <tr> */}
                        {/* <td><img src="assets/images/avatar-2.jpg" className="img-circle" height="50"/></td> */}
                        {/* <td>{metaDataWriter}</td>
                                        <td></td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>

                            <div className="form-group mb-30 width-100 row">
                              <label className="col-md-4 control-label">
                                Crew
                              </label>
                              <div className="col-md-8">
                                <div className="table-responsive table-shoot">
                                  <table className="table">
                                    <tbody>
                                      {metaDataCrew &&
                                        metaDataCrew.map((actor) => (
                                          <tr>
                                            <td>
                                              <img
                                                src={actor.image}
                                                className="img-circle"
                                                height="50"
                                              />
                                            </td>
                                            <td>{actor.name}</td>
                                            <td>Actor</td>
                                          </tr>
                                        ))} */}

                        {/* <tr>
                                        <td><img src="assets/images/avatar-2.jpg" className="img-circle" height="50" /></td>
                                        <td>Anil Ravipudi</td>
                                        <td>Actor</td>
                                      </tr> */}
                        {/* </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>

                            <div className="form-group width-100 mb-30 row">
                              <label className="col-md-4 control-label"></label>
                              <div className="col-md-8">
                                <Link>
                                  <button
                                    type="button"
                                    onClick={() => postMetaData(lessionId)}
                                    className="btn btn-success btn-login waves-effect waves-light mr-3"
                                  >
                                    Save
                                  </button>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div> */}
                        {/*/////////////////////////////// meta dat end here //////////////////// */}

                        {/* <div className="tab-pane" id="images" role="tabpanel">
                          <div className="panel-body p-20">
                            <div className="form-group mb-30 width-100 row">
                              <label className="col-md-4 control-label">
                                Upload Thumbnail Image
                                <br />
                                <span className="size">(320 x 180 px)</span>
                              </label>
                              <div className="col-md-8">
                                <input
                                  onChange={handleChange}
                                  name="thumbnail"
                                  type="file"
                                  className="form-control input-field"
                                />
                                <div>
                                  <img
                                    classNameName="img-fluid mt-2"
                                    style={{
                                      height: "125px",
                                      width: "235px",
                                    }}
                                    alt="200x200"
                                    src={
                                      lession.thumbnail
                                        ? lession.thumbnail
                                        : "https://sgp1.digitaloceanspaces.com/storage.tellytell.com/thumbnail-default.png"
                                    }
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="form-group mb-30 width-100 row">
                              <label className="col-md-4 control-label">
                                Upload Banner Image
                                <br />
                                <span className="size">(1125 x 451 px)</span>
                              </label>
                              <div className="col-md-8">
                                <input
                                  type="file"
                                  name="banner"
                                  onChange={handleChange}
                                  className="form-control input-field"
                                />
                                <div>
                                  <img
                                    classNameName="img-fluid mt-2"
                                    style={{
                                      width: "235px",
                                      height: "125px",
                                    }}
                                    alt="200x200"
                                    src={
                                      lession.banner
                                        ? lession.banner
                                        : "https://sgp1.digitaloceanspaces.com/storage.tellytell.com/banner-default.png"
                                    }
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="form-group mb-30 width-100 row">
                              <label className="col-md-4 control-label"></label>
                              <div className="col-md-8">
                                <button
                                  onClick={onUpdatefirst}
                                  style={{ width: "120px" }}
                                  disabled={!validForm}
                                  type="button"
                                  className="btn btn-success btn-login waves-effect waves-light mr-3"
                                >
                                  <ClipLoader loading={loading} size={18} />
                                  {!loading && "Save"}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div> */}

                        {/* launch panel */}

                        {/* <div className="tab-pane" id="launch" role="tabpanel">
                          <div className="panel-body p-20">
                            <div className="form-group mb-30 width-100 row">
                              <label className="col-md-4 control-label">
                                Date
                              </label>
                              <div className="col-md-8">
                                <div className="form-group width-100">
                                  <div className="input-group">
                                    <input
                                      type="datetime-local"
                                      value={lession.launchDate}
                                      name="launchDate"
                                      onChange={(e) => {
                                        setLession({
                                          ...lession,
                                          launchDate: e.target.value,
                                        });
                                        formData.set(
                                          "launchDate",
                                          e.target.value
                                        );
                                      }}
                                    /> */}
                        {/* <DatePicker
                      
                                      selected={lession.launchDate}
                                      name="launchDate"
                                      onChange={(date) => {
                                        setLession({
                                          ...lession,
                                          launchDate: date,
                                        });
                                        formData.set(
                                          "launchDate",
                                          date.toISOString()
                                        );
                                      }}
                                    /> */}

                        {/* <div className="input-group-append">
                                      <span className="input-group-text">
                                        <i
                                          className="fa fa-calendar"
                                          aria-hidden="true"
                                        ></i>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="form-group m-b-0 row">
                              <div className="col-md-4"></div>
                              <div className="col-md-8">
                                <button
                                  onClick={onUpdatelast}
                                  style={{ width: "120px" }}
                                  disabled={!validForm}
                                  type="button"
                                  className="btn btn-success btn-login waves-effect waves-light mr-3"
                                >
                                  <ClipLoader loading={loading} size={18} />
                                  {!loading && "Save"}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div> */}

                        {/* video panel */}
                        <div className='tab-pane' id='video' role='tabpanel'>
                          <div className='panel-body p-20'>
                            <div className='form-group width-100 row'>
                              <label className='col-md-4 control-label'>
                                Upload Video*
                                <br />
                                <span className='size'>
                                  (mp4 file format only)
                                </span>
                              </label>
                              <div className='col-md-8'>
                                <input
                                  type='file'
                                  onChange={handleChange}
                                  name='video'
                                  accept='video/mp4,video/x-m4v,.mkv,video/*'
                                  className='form-control input-field mb-1'
                                />
                                <Player key={lession.video} className="mb-1">
                                  <source src={lession.video} />
                                </Player>
                                <small>File size must be less than 500mb</small>
                              </div>
                            </div>
                            {/* Progress Bar */}
                            {progress > 0 && (
                              <div className="form-group width-100 row">
                                <div className="col-md-8 offset-md-4">
                                  <div className="progress">
                                    <div
                                      className="progress-bar progress-bar-striped progress-bar-animated"
                                      role="progressbar"
                                      style={{ width: `${progress}%` }}
                                      aria-valuenow={progress}
                                      aria-valuemin="0"
                                      aria-valuemax="100"
                                    >
                                      {progress}%
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            <div className='form-group width-100 row'>
                              <label className='col-md-4 text-danger control-label'></label>
                              <div className='col-md-8'>
                                <button
                                  onClick={onSubmit}
                                  style={{ width: "120px" }}
                                  disabled={!lessionId}
                                  type='button'
                                  className='btn btn-success btn-login waves-effect waves-light mr-3'>
                                  <ClipLoader loading={loading} size={18} />
                                  {!loading && "Save"}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='form-group row '>
                        <div className='col-md-4'></div>
                        <div className='col-md-8 text-left pl-3'>
                          <div className='form-group width-100'>
                            <span className='text-danger'>{error}</span>
                            <br />
                            <br />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
